import { EventEmitter, Injectable } from '@angular/core';
import { Viewport } from '../../../../swagger-api';

@Injectable({
  providedIn: 'root',
})
export class ViewportService {
  public viewportUpdated: EventEmitter<Viewport> = new EventEmitter<Viewport>();

  public updateViewport(viewport: Viewport): void {
    this.viewportUpdated.emit(viewport);
  }
}
